import { PAYMENT_NEW_ORIGIN_PARAM } from "./PaymentNewOrigin";
import { FILTERS_KEYS } from "./PaymentsFilters";

import type { UUID } from "utils";

import type { PaymentsFilterType } from "../models/PaymentsFilters";
import type { PaymentNewOrigin } from "./PaymentNewOrigin";

const BASE_URL = "/accounts";
const PAYMENTS_NEW_URL = `${BASE_URL}/payments/new`;

export const PAGE_URLS = {
  payments: `${BASE_URL}/payments`,
  getLinkToPaymentsByType: (type: PaymentsFilterType) =>
    `${BASE_URL}/payments?${FILTERS_KEYS.TYPE}=${type}`,
  paymentsNew: PAYMENTS_NEW_URL,
  getLinkToPaymentsNew: (origin?: PaymentNewOrigin) =>
    origin
      ? `${PAYMENTS_NEW_URL}?${PAYMENT_NEW_ORIGIN_PARAM}=${origin}`
      : PAYMENTS_NEW_URL,
  paymentDetails: `${BASE_URL}/payments/:id`,
  getLinkToPaymentDetails: (id: UUID) => `${BASE_URL}/payments/${id}`,
  paymentRefund: `${BASE_URL}/payments/:id/refund`,
  getLinkToPaymentRefund: (accountId: UUID, sourcePaymentId: UUID) =>
    `${BASE_URL}/payments/${sourcePaymentId}/refund?accountId=${accountId}`,
};
